// extracted by mini-css-extract-plugin
export default {"root":"Gallery_root__1fk85","list":"Gallery_list__1KqD5","item":"Gallery_item__12HFF"};